import React, { useState, useCallback, useEffect } from "react";
import AsyncSelect from "react-select/async";
import { getCityByCountry } from "app/services/hotel/hotelService";
import queryStringService from "app/services/queryStringService";

const CityAutoComplete = ({
  // selectedCityValue,
  // setSelectedCityValue,
  // setInputCityValue,
  // selectedCountryValue,
  values,
  setFieldValue,
}) => {
  const [selectedValue, setSelectedValue] = useState(null);
  const [inputValue, setInputValue] = useState("");
  const [defaultOptions, setDefaultOptions] = useState([]);
  // Handle input change event
  const handleInputChange = (value) => {
    setInputValue(value);
  };
  // Handle selection change
  const handleChange = (value) => {
    setSelectedValue(value);
    setFieldValue("searchCriteria.cityId", value.id);
    setFieldValue("searchCriteria.cityName", value.label);
    setFieldValue("address.city.name", value.label);
  };
  const fetchInitialOptions = async () => {
    const query = queryStringService.getQueryStringFromObj({
      countryId: 1,
      searchText: "Kolkata",
    });

    const { data } = await getCityByCountry(query);
    const options =
      data?.data
        ?.filter(
          (item) => item.type == "MULTI_CITY_VICINITY" || item.type == "CITY"
        )
        .map((item) => ({
          id: item.id,
          label: `${item.cityName.toUpperCase()}`,
        })) || [];

    setDefaultOptions(options);

    // Auto-select the first option
    if (options.length > 0) {
      setSelectedValue(options[0]);
      setFieldValue("searchCriteria.cityId", options[0].id);
      setFieldValue("searchCriteria.cityName", options[0].label);
      setFieldValue("address.city.name", options[0].label);
    }
  };

  useEffect(() => {
    fetchInitialOptions();
  }, []);

  // Load options using API call only if selectedCountryValue exists
  const loadOptions = useCallback(
    async (inputValue) => {
      if (!values?.searchCriteria.countryId) return [];

      const query = queryStringService.getQueryStringFromObj({
        countryId: values?.searchCriteria.countryId,
        searchText: inputValue.trim().toLowerCase(),
      });

      try {
        const { data } = await getCityByCountry(query);
        return (
          data?.data
            ?.filter(
              (item) =>
                item.type == "MULTI_CITY_VICINITY" || item.type == "CITY"
            )
            .map((item) => ({
              id: item.id,
              label: `${item.cityName.toUpperCase()}`,
            })) || []
        );
      } catch (error) {
        console.error("Error fetching cities:", error);
        return [];
      }
    },
    [values?.searchCriteria.countryId]
  );

  // useEffect(() => {
  //   setInputCityValue("");
  //   setSelectedCityValue("");
  // }, [selectedCountryValue]);

  return (
    <AsyncSelect
      cacheOptions
      defaultOptions={defaultOptions}
      value={selectedValue}
      getOptionLabel={(e) => e.label}
      getOptionValue={(e) => e.id}
      loadOptions={loadOptions}
      onInputChange={handleInputChange}
      onChange={handleChange}
      name="searchCriteria.cityName"
      placeholder="Select City Name"
      isDisabled={!values?.searchCriteria.countryId} // Disable when no country is selected
    />
  );
};

export default CityAutoComplete;
